const PROD_URL = "https://admin.oncquestlabs.com";


// const PROD_URL = "https://oncquest-admin-uat.abym.us";
//const PROD_URL = "https://admin.oncquestlabs.com/preprod";
// const PROD_URL = "https://preprod-admin.oncquestlabs.com";


const BASE_URL = PROD_URL;
export const API_BASE_URL = `${BASE_URL}/api`;
export const Email_BASE_URL = `${BASE_URL}`;
export const Url = {
  login: "/auth/login",
  register: "/auth/register",
  apiGetToken: "/api-get-token",
  dashboard: "/dashboard",
  testimonials: "/testimonials/list",
  state: "/states",
  city: "/cities",
  centerCity: "/citiescentreslist",
  departmentList: "/departments",
  departmentDetails: "/department/details",
  departmentBySlug: "/department",
  doctorList: "/doctors",
  doctorDetails: "/doctor",
  doctorBySlug: "/doctor",
  centerList: "/centres",
  centerDetails: "/centre/details",
  centerBySlug: "/centre",
  nearByCenter: "/centre/nearby",
  tests: "/tests",
  testBySlug: "/test",
  testById: "/test/details",
  packages: "/packages",
  packageById: "/package/details",
  packageBySlug: "/package",
  packageComponent: "/package/components",
  facilities: "/facilities",
  pgoptions: "/pgoptions",
  subcategories: "/subcategories",
  querySubmit: "/query/submit",
  enquirySubmit: "/enquiry/submit",
  enquiryPartner: "/enquiry/partner",
  uploadAttachment: "/upload-attachment",
  uploadPrecription: "/booking/uploadPrescriptions",
  bookingEnquiry: "/booking/enquiry",
  generalDetails: "/general/details",
  cme: "/cme",
  newsAndUpdate: "/news-events",
  pressRealease: "/pressrelease/list",
  pressreleaseBySlug: "/pressrelease",
  allOffer: "/coupons",
  offerById: "/coupon/details",
  faq: "/faqs",
  seoDetail: "/seo-details",
  sendOtp: "/send-otp",
  verifyOtp: "/verify-otp",
  slot: "/v2/available/slots",
  bookingValidation: "/v2/booking-validation",
  createBooking: "/v2/booking/create",
  createHomeCollection: "/create-booking",
  updateBooking: "/v2/booking/update",
  storeCartData: "/v2/cart/data",
  jobList: "/jobs",
  jobApply: "/apply-job",
  brochures: "/brochure/list",
  newsletter: "/newsletter/subscribe",
  collectionForm: "/create-collection",
  membershipForm: "/membership/submit",
  getLocality: "/localities",
  sendEmail: `${BASE_URL}/cronjob/notifications/email`,
  sendSms: `${BASE_URL}/cronjob/notifications/sms`,

  getProfile: "/profile",
  editProfile: "/profile/edit",
  patientList: "/getPatientList",
  createPatient: "/createPatient",
  updatePatient: "/updatePatient",
  getMasterArr: "/getMasterArr",
  getCityList: "/getCityList",
  getPincodeList: "/v2/pincode-list",
  getStateList: "/getStateList",
  deleteFamilyMember: "/deleteFamilyMember",
  updateFamilyMember: "/updateFamilyMember",
  addFamilyMember: "/addFamilyMember",
  addressList: "/v2/customer/address/list",
  addAddress: "/v2/customer/address/add",
  updateAddress: "/v2/customer/address/update",
  orderList: "/v3/booking/history",
  bookingDetails: "/v2/booking/details",
  bookingCancel: "/v2/booking/cancel",
  refundBooking: "/v2/booking/refund-initiate",
  termsCondition: "/terms-conditions",
  paymentHistory: "/transaction/list",
  userActivityLog: "/v2/user/activity-logs",
  cartlist: "/v2/cart/update",
  refundDetails: "/v1/payment/trackRefund",
};
